import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { useAppSelector } from '../../store/hooks/hooks';
import { useEffect } from 'react';
import { Fade } from '@mui/material';

export default function MessageSnackbar() {
    const [open, setOpen] = React.useState(false);
    const message = useAppSelector((state: any) => state.user.message)

    const handleClick = () => {
        setOpen(true);
    };
    useEffect(() => {
        if (message.length > 0) {
            handleClick()
        }
    }, [message])

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    return (
        <div>
            <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                message={message}
                TransitionComponent={Fade}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
            />
        </div>
    );
}